import React, { CSSProperties, useState } from "react";
import { Image } from "antd";
import { getInitials } from "./NameAvatar";

type SizeType = "xl" | "larger" | "large" | "middle" | "small" | "mini" | "xs";

type SizeStyleType = {
    [key in SizeType]: CSSProperties;
};

const SizeStyle: SizeStyleType = {
    xl: {
        width: 130,
        height: 130,
        fontSize: 36,
        borderRadius: 0,
        borderBottom: "none",
    },
    larger: {
        width: 96,
        height: 96,
        fontSize: 36,
        fontWeight: 700,
        borderRadius: 0,
        borderBottom: "none",
    },
    large: {
        width: 80,
        height: 80,
        fontSize: 24,
    },
    middle: {
        width: 60,
        height: 60,
        fontSize: 24,
    },
    small: {
        width: 48,
        height: 48,
        fontSize: 20,
    },
    mini: {
        width: 36,
        height: 36,
        fontSize: 16,
    },
    xs: {
        width: 20,
        height: 20,
        borderRadius: 4,
        fontSize: 14,
    },
};

export interface CompanyImageProps {
    name?: string;
    logo?: string;
    size?: SizeType;
    className?: string;
    sharp?: boolean;
    theme?: "light" | "dark";
}

export const CompanyImage: React.FC<CompanyImageProps> = ({
    logo = "",
    name = "",
    size = "middle",
    className,
    sharp = false,
    theme = "light",
}) => {
    const [imgError, setImgError] = useState(false);

    const handleImgError = () => {
        setImgError(true);
    };

    const sizeStyle = SizeStyle[size];
    sizeStyle.borderRadius = sharp ? 0 : (sizeStyle.borderRadius ?? 8);
    sizeStyle.borderBottom = sharp ? "none" : sizeStyle.borderBottom;

    const background = theme === "light" ? "#F5F5F5" : "#35507A";
    const color = theme === "light" ? "#666666" : "#FFFFFF";

    return (
        <div
            className={className}
            style={{
                borderBottom: "1px solid #D9D9D9",
                ...sizeStyle,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "inherit",
                background,
                overflow: "hidden",
            }}
            data-testid="company-image-box"
        >
            {logo && !imgError ? (
                <Image
                    src={logo}
                    preview={false}
                    data-testid="company-image"
                    onError={handleImgError}
                ></Image>
            ) : (
                <span
                    style={{
                        color,
                        fontWeight: 700,
                        fontSize: sizeStyle.fontSize,
                    }}
                >
                    {getInitials(name)}
                </span>
            )}
        </div>
    );
};
